import { render, staticRenderFns } from "./SuccessPasswordModal.vue?vue&type=template&id=c8f9e564&"
import script from "./SuccessPasswordModal.vue?vue&type=script&lang=js&"
export * from "./SuccessPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports